export default "__VITE_ASSET__CsfaVkAe__"